<template>
    <div class="dropdown" v-if="tags_list.length>0">
        <b-button-group>
            <button class="btn btn-white" @click="clear" v-if="localValue && localValue.length>0">
                <span class="fe fe-x"></span>
            </button>
            <b-dropdown variant="white" right :text="label || $t('Specialty')">
                <div v-for="(tag, index) in tags_list" :key="index" class="dropdown-item pl-3 border-right border-3">
                    <b-form-checkbox v-model="localValue" :value="tag._id">{{tag.label}}</b-form-checkbox>
                </div>
            </b-dropdown>
        </b-button-group>
    </div>
</template>
<script>

import { mapActions, mapState, mapGetters } from 'vuex';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
    name: 'Tags',
    props: ['value'],
    data() {
        return {
            localValue: [],
        }
    },
    components: {
        Treeselect,
    },
    created() {
        // console.log('created');
        if (this.value)
            this.localValue = this.value;
    },
    watch: {
        localValue(newValue) {
            this.$emit('input', newValue);
        },
        value(newValue) {
            this.localValue = newValue;
        }
    },
    computed: {
        ...mapGetters('specialty', { findDataInStore: 'find', get: 'get' }),
        tags_list() {
            return this.findDataInStore().data;
        },
        label() {
            if (!this.localValue) return false;
            let items = this.localValue.map(item => {

                return this.get(item).label;
            });
            return items.join(', ');
        }

    },
    methods: {
        clear() {
            this.localValue = [];
        },
        memberStyles(color) {
            return 'border-right:3px solid ' + color;
        },
        updateValue(value) {
            this.localValue = value;
        },
    }

}
</script>